// SPDX-FileCopyrightText: OpenTalk GmbH <mail@opentalk.eu>
//
// SPDX-License-Identifier: EUPL-1.2
export enum GridViewOrder {
  FirstJoined = 'firstJoined',
  VideoFirst = 'videoFirst',
  ModeratorsFirst = 'moderatorsFirst',
}
